import { render, staticRenderFns } from "./EmployeeAssignmentManager.vue?vue&type=template&id=ec4e79f2&scoped=true&"
import script from "./EmployeeAssignmentManager.vue?vue&type=script&lang=js&"
export * from "./EmployeeAssignmentManager.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeAssignmentManager.vue?vue&type=style&index=0&id=ec4e79f2&scoped=true&lang=css&"
import style1 from "./EmployeeAssignmentManager.vue?vue&type=style&index=1&lang=css&"
import style2 from "./workforce-viewport-modal.css?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec4e79f2",
  null
  
)

export default component.exports